// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"406":"1e6896b3","444":"62d0d5d5"}[chunkId] + ".chunk.css";
};